// Conditional privy popup
const HIDE_PRIVY_NOV_2020 = 'hide_privy_nov_2020';

// eslint-disable-next-line
function getCookie(e) { for (let n = `${e}=`, t = decodeURIComponent(document.cookie).split(';'), o = 0; o < t.length; o++) { for (var r = t[o]; r.charAt(0) == ' ';)r = r.substring(1); if (r.indexOf(n) == 0) return r.substring(n.length, r.length); } return ''; }

export default {
  mounted() {
    const userId = this.$store?.state?.session?.user?.id;
    const scriptElement = document.querySelector('[src="https://widget.privy.com/assets/widget.js"]');
    const routePath = this.$route?.path;
    const allowByQueryParam = () => (
      !!this.$route.query?.utm_source && !getCookie(HIDE_PRIVY_NOV_2020));
    const privyDealSlugs = this.$config.privyDealSlugs?.split(',') || [];
    const isValidPDPSlug = privyDealSlugs.some((x) => routePath.includes(x));

    if ((!userId && !scriptElement) || isValidPDPSlug) {
      // Needed for privy, var _d_site will not work inside script
      window._d_site = 'BB924CED6226F3A9A3091210'; // eslint-disable-line no-underscore-dangle

      // Conditionally load privy
      if (allowByQueryParam() || isValidPDPSlug) {
        const d = new Date();
        d.setTime(d.getTime() + (24 * 60 * 60 * 1000)); // Expire in 1 day

        const expires = `expires=${d.toUTCString()}`;
        document.cookie = `${HIDE_PRIVY_NOV_2020}=true;${expires};path=/`;

        // BEGIN -- Privy Snippet
        /* eslint-disable */
        var _d_site = _d_site || 'BB924CED6226F3A9A3091210';
        (function (p, r, i, v, y) {
          p[i] = p[i] || function () { (p[i].q = p[i].q || []).push(arguments); };
          v = r.createElement('script'); v.async = 1; v.src = 'https://widget.privy.com/assets/widget.js';
          y = r.getElementsByTagName('script')[0]; y.parentNode.insertBefore(v, y);
        }(window, document, 'Privy'));
        /* eslint-enable */
        // END -- Privy Snippet
      }
    }
  },
  beforeDestroy() {
    // needed to remove privy when visiting other pages due to SPA
    const scriptElement = document.querySelector('[src="https://widget.privy.com/assets/widget.js"]');

    if (scriptElement) scriptElement.remove();
    if (window._d_site) delete window._d_site; // eslint-disable-line no-underscore-dangle
  },
};
